'use strict';

import * as funciones from './functions.js'

funciones.reactorInitAOS();
funciones.reactorMenu();
funciones.reactorCarruselProducto();
funciones.reactorGaleriaCarrusel();
funciones.reactorInputNumber();
funciones.reactorCompartir();
funciones.reactorPlayVideo();
funciones.ppMensaje();
//funciones.ppMasonry();
//funciones.ppMasonrycarganews();
funciones.suscribeForm();
funciones.popupModular();
funciones.ppueblosFormulario();
funciones.ppueblosFormulario2();
funciones.ppueblosFormulariocontacto2();
funciones.ppueblosModalFormulario();
funciones.ppueblosModalFormulario2();
funciones.cargar_noticias();
funciones.cargar_corporativos();
funciones.ppModalPopup();
funciones.ppueblosFormularioRegistroTienda();
funciones.selectorCreadorMobile();
funciones.setTabByURL();
funciones.updateMiniCart();
